import { RankIcon } from 'src/components/insights/icons/rank'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import dynamic from 'next/dynamic'
import preview from 'src/assets/images/widgets-previews/brand-rank-list.png'

const BrandRankList = dynamic(() => import('src/components/insights/rank/rank-list/by-brand-for-report'), {
  ssr: false,
})

const CategoryRankList = dynamic(() => import('src/components/insights/rank/rank-list/by-category-for-report'), {
  ssr: false,
})

export const BrandRankListWidget: InsightBuilderWidget = {
  id: 'brand-rank-list',
  name: 'Brand Rank List',
  type: 'Rank',
  icon: RankIcon,
  component: BrandRankList,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}

export const CategoryRankListWidget: InsightBuilderWidget = {
  id: 'category-rank-list',
  name: 'Category Rank List',
  type: 'Category Rank',
  icon: RankIcon,
  component: CategoryRankList,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
